
<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-card class="rounded-xl" max-width="400">
        <v-card-title class="headline d-flex justify-center">
          Подтверждение оплаты
        </v-card-title>

        <v-card-text>
          Дайте нам несколько минут, чтобы мы проверили детали платежа, если
          возникли какие-то проблемы, воспользуйтесь одним из наших контактов,
          чтобы решить вопрос.
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>


<script>
// import api from "../config/api";

export default {
  data: () => ({}),

  //   beforeRouteEnter(to, from, next) {
  //     next((vm) => {
  //       var token = localStorage.getItem("token");
  //       if (token) {
  //         vm.$router.push({ name: "home" });
  //       }
  //     });
  //   },
};
</script>